import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import { createApp } from 'vue'
import { createYmaps } from 'vue-yandex-maps'

import App from '@/App.vue'
import '@/assets/styles/tokens.css'
import '@/assets/styles/main.scss'
import { env } from '@/config/env'
import { i18n } from '@/i18n'
import { options } from '@/plugins/PrimeVue'
import { initSentry } from '@/plugins/sentry'
import { router } from '@/router'

const app = createApp(App)

/* До остальных плагинов: их ошибки на старте иначе уйдут в пустоту */
initSentry(app)

app
  .use(createPinia())
  .use(i18n)
  .use(router)
  .use(PrimeVue, options)
  // search — тем же ключом: по нему ищутся адреса в строке поиска
  .use(createYmaps({ apikey: env.mapKey, servicesApikeys: { search: env.mapKey } }))
  .use(ToastService)
  .use(ConfirmationService)
  .mount('#app')
